export default function () {


    function updateAnchor(newAnchor) {
        const currentUrl = window.location.href;
        const baseUrl = currentUrl.split('#')[0];
        const newUrl = `${baseUrl}#${newAnchor}`;

        history.pushState(null, '', newUrl);
    }

    const faqListSpan = document.querySelectorAll('.faq-list span');

    faqListSpan.forEach(span => {
        span.addEventListener('click', function () {
            span.parentElement.classList.toggle('show');
            span.parentElement.classList.remove('instant');

            const id = span.parentElement.getAttribute('id');

            if (!id) return;
            updateAnchor(`${id}`);


        });
    });


    let hash = window.location.hash;
 
    if (!hash || !hash.startsWith("#faq")) return;
     
 
    const elem = document.getElementById(`${hash.substring(1)}`);
  
    if (elem) {
        elem.classList.add('show', 'instant');
        elem.parentElement.closest('li').classList.add('show', 'instant');
    }


}